/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

import { ProposalView } from 'features/Proposal/pages';

import { ScrollTop } from 'primereact/scrolltop';

function ProjectProposalCreatePage() {
    return (
        <LayoutProvider>
            <Layout
                // eslint-disable-next-line react/jsx-indent-props
                style={{
                    maxHeight: 'calc(100vh - 9rem)',
                    overflowY: 'auto',
                    borderRadius: '12px',
                    border: '1px solid var(--surface-border)',
                    backgroundColor: 'white',
                }}
            >
                <>
                    <ProposalView />
                    <ScrollTop target="parent" />
                </>
            </Layout>
        </LayoutProvider>
    );
}

export default ProjectProposalCreatePage;
